import { Calendar } from './Calendar'
import { differenceInMonths } from 'date-fns'
import { CurrentMonthIndicator } from './CurrentMonthIndicator'

import styles from './RangeDatePicker.module.scss'

export interface RangeDatePickerProps {
  startMonth: Date
  closeMonth?: Date
  onChange: (closeDateIndex: number) => void
}

export const RangeDatePicker = ({ onChange, closeMonth, startMonth }: RangeDatePickerProps) => {
  const i = closeMonth ? differenceInMonths(closeMonth, startMonth) : -1

  return (
    <div className={styles.el}>
      {i >= 0 && <CurrentMonthIndicator index={i} />}
      <Calendar onClick={onChange} startMonth={startMonth} currIndex={i} />
    </div>
  )
}
